import { NavigationPanelData } from '@frontend-mono/shared-ui-kit';

export enum AccessControlRoutes {
  ROLE_MANAGEMENT = 'role-management',
  RIGHTS_MANAGEMENT = 'rights-management',
  DETAIL = 'detail',
  NEW_ROLE = 'new-role',
}

export const accessControlRoutingData: NavigationPanelData[] = [
  {
    name: 'Role management',
    link: AccessControlRoutes.ROLE_MANAGEMENT,
  }, {
    name: 'Rights  management',
    link: AccessControlRoutes.RIGHTS_MANAGEMENT,
  }
];

export enum RoleManagementMode {
  EDIT,
  CREATE
}
